module.exports = __webpack_public_path__ + "svg/aiohttp.d77f1b.svg";